module.exports = __webpack_public_path__ + "img/10.a5c6b3ea.png";